import { TENANT_FR, TENANT_IT } from 'shared/consts'
import { type Tenant } from 'types/shopConfig'

export const getMinimumDiscountToShow = (tenant: Tenant) => {
  const MINIMUM_OFFER_DISCOUNT_TO_SHOW_GENERAL = 5
  const MINIMUM_OFFER_DISCOUNT_TO_SHOW_IT_FR = 2
  const internationalTenants = [TENANT_FR, TENANT_IT]

  return internationalTenants.includes(tenant)
    ? MINIMUM_OFFER_DISCOUNT_TO_SHOW_IT_FR
    : MINIMUM_OFFER_DISCOUNT_TO_SHOW_GENERAL
}
